import React from 'react';
import { Outlet } from 'react-router';

import { useRolesMatch, Roles, and, not, or } from '@/js/libs/use-auth';

import Status from 'src/scenes/Status';
import { useRouteParams } from '../hooks';
import { BroadcastUrlType } from '../types';

const BROADCAST_ROLES = {
  [BroadcastUrlType.TV]: Roles.MANAGE_TV_PRODUCTS,
  [BroadcastUrlType.RADIO]: Roles.MANAGE_RADIO_PRODUCTS,
};

export const BroadcastRoleChecker = React.memo(function BroadcastRoleChecker() {
  const { broadcastType } = useRouteParams();
  const role = BROADCAST_ROLES[broadcastType];
  const hasAccess = useRolesMatch({ roles: and(role, not(or(Roles.POSTNETZ_BRANCH_USER, Roles.READ_ONLY_POSTNETZ_BRANCH_USER))) });

  if (!hasAccess) {
    return <Status.NotFound />;
  }

  return <Outlet />;
});
